import React, { CSSProperties } from 'react'
import Skeleton from 'react-loading-skeleton'

import { cn } from '@/lib/utils'

interface Props {
  className?: string
  style?: CSSProperties
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>
}

const SkeletonBox: React.FC<Props> = ({ className, style, wrapperProps }) => {
  return (
    <div
      {...wrapperProps}
      className={cn('w-full grow', wrapperProps?.className)}
    >
      <Skeleton
        containerClassName="block lh-1"
        className={cn(className)}
        style={{ height: '200px', ...style }}
      />
    </div>
  )
}

export default SkeletonBox
